import { useKidContext } from "./layout";
import { useChildDetail } from "@/hooks/use-parent-data";
import { KidProfileCard } from "@/components/kid/kid-profile-card";
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate } from "react-router-dom";

export default function KidHomePage() {
  const { childId } = useKidContext();
  const { data, isLoading } = useChildDetail(childId);
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="flex flex-col items-center gap-5 px-6 pt-8 pb-6">
        <Skeleton className="w-24 h-24 rounded-full" />
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-8 w-36 rounded-full" />
        <Skeleton className="h-16 w-40 rounded-2xl" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 p-6 text-center">
        <div className="text-5xl">😕</div>
        <p className="text-lg font-semibold text-gray-700">Couldn't load your profile</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <KidProfileCard
        firstName={data.profile.firstName}
        lastName={data.profile.lastName}
        ballLevel={data.profile.ballLevel}
        points={data.profile.points}
      />

      {/* Quick action tiles */}
      <div className="grid grid-cols-2 gap-4 px-6 pb-6">
        <button
          onClick={() => navigate(`/kid/${childId}/missions`)}
          className="flex flex-col items-center justify-center gap-2 bg-white rounded-2xl p-5 shadow-sm border border-gray-100 active:scale-95 transition-transform"
        >
          <span className="text-4xl">🏆</span>
          <span className="font-bold text-gray-800">Missions</span>
          <span className="text-xs text-gray-500">Complete challenges</span>
        </button>
        <button
          onClick={() => navigate(`/kid/${childId}/badges`)}
          className="flex flex-col items-center justify-center gap-2 bg-white rounded-2xl p-5 shadow-sm border border-gray-100 active:scale-95 transition-transform"
        >
          <span className="text-4xl">⭐</span>
          <span className="font-bold text-gray-800">Badges</span>
          <span className="text-xs text-gray-500">See your awards</span>
        </button>
      </div>
    </div>
  );
}
